import GlobalContext from '../bootstrap';
import initImagePopups from '../editor-content/img-popout';
import initPageFeedbackButtons from '../feedback/thumbs';
import initInformationSearch from '../infosearch';
import initLazyLoadedStyles from '../lazyloading/styles';
import initPrintable from '../print';
import initScrollToTop from '../scrolltotop';
import initTextToSpeachButtons from '../texttospeach';
import initTypeaheads from '../typeahead';

class InformationArticlePage extends GlobalContext {
    constructor() {
        super();
        this._initialiseComponents();
    }

    _initialiseComponents(): void {
        initLazyLoadedStyles();

        initPageFeedbackButtons();

        initImagePopups();

        initTypeaheads();

        initTextToSpeachButtons();

        initInformationSearch();

        initScrollToTop();

        initPrintable();
    }
}

if ( !window.articlePage ) {
    window.articlePage = new InformationArticlePage();
}
